var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PhoneCall"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5664 3.90625C16.8915 4.26189 18.0998 4.95982 19.07 5.92999C20.0402 6.90016 20.7381 8.10845 21.0938 9.43359",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7559 6.92383C15.5529 7.13549 16.2797 7.55409 16.8628 8.13718C17.4459 8.72027 17.8645 9.44715 18.0762 10.2441",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.0332 12.1875C9.83713 13.8477 11.1796 15.1867 12.8418 15.9863C12.9644 16.0444 13.1 16.0695 13.2353 16.0592C13.3706 16.049 13.5008 16.0036 13.6133 15.9277L16.0547 14.2969C16.1626 14.2237 16.2872 14.1791 16.417 14.1671C16.5468 14.1552 16.6775 14.1763 16.7969 14.2285L21.3672 16.1914C21.5234 16.2564 21.6539 16.371 21.7386 16.5174C21.8233 16.6639 21.8575 16.8341 21.8359 17.002C21.6911 18.1326 21.1392 19.1716 20.2836 19.9248C19.428 20.6779 18.3273 21.0935 17.1875 21.0938C13.6651 21.0938 10.287 19.6945 7.79624 17.2038C5.30552 14.713 3.90625 11.3349 3.90625 7.8125C3.90651 6.67266 4.32208 5.57196 5.07522 4.71636C5.82836 3.86077 6.86744 3.30892 7.99805 3.16406C8.16586 3.14251 8.3361 3.17671 8.48256 3.26141C8.62902 3.34612 8.74358 3.47661 8.80859 3.63281L10.7715 8.21289C10.8225 8.33042 10.8439 8.4587 10.8337 8.58642C10.8234 8.71415 10.782 8.8374 10.7129 8.94531L9.08203 11.4258C9.00942 11.538 8.96681 11.6669 8.95826 11.8003C8.94971 11.9336 8.97552 12.067 9.0332 12.1875V12.1875Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.34dd5c112137d7d260f638c881ef56c5.svg";
export { ForwardRef as ReactComponent };